import { IoMdClose } from "react-icons/io";
import { GrSearch } from "react-icons/gr";
import TabContainer from "../../../../components/Tab/TabContainer";
import useSelectBrand from "#hooks/styles/useSelectBrand";
const SearchInput = ({
  formData,
  handleChange,
  search,
  activeTab,
  handleTabClick,
  categoryKeys,
  clearInput,
}) => {
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (!formData.keyword && formData.req_page > 1) {
        return;
      }
      search();
    }
  };

  const handleOnClick = (e) => {
    if (!formData.keyword && formData.req_page > 1) {
      return;
    }
    search();
  };

  const { color } = useSelectBrand();
  return (
    <>
      <div className="sticky flex flex-col  py-2 bg-white top-[4.5rem] z-50">
        <TabContainer
          tabs={categoryKeys}
          activeTab={activeTab}
          onTabClick={handleTabClick}
        />
        <div className="mt-5 mb-2.5 border-b border-neutral-200"></div>
        <label
          className={`flex items-center gap-2 bg-white input input-bordered border-${color}`}
        >
          <input
            type="text"
            className="w-full font-semibold grow placeholder:text-neutral-400"
            placeholder="제조사 또는 브랜드를 입력해주세요"
            onKeyDown={handleKeyPress}
            onChange={(e) => handleChange(e)}
            name="keyword"
            value={formData.keyword}
          />
          {formData.keyword && (
            <button
              className="flex items-center justify-center rounded-full w-7 h-7 bg-neutral-50"
              onClick={clearInput}
            >
              <IoMdClose style={{ color: "#A3A3A3" }} />
            </button>
          )}

          <button onClick={handleOnClick}>
            <GrSearch className="text-2xl" />
          </button>
        </label>
      </div>
    </>
  );
};

export default SearchInput;
